import React from 'react';
import { View, Text, ScrollView } from 'react-native';
import { useTranslation } from 'react-i18next';
import { HelpdeskIssueStatus, TopicHelpdeskIssueItem } from '../../client/interfaces';
import { cln } from '../../utils/classnames';
import TableCell from '../TableCell';

interface Props {
  rows: TopicHelpdeskIssueItem[];
  title?: string;
  emptyText?: string;
}

const HelpdeskIssueSimpleTable: React.FC<Props> = ({ rows, title, emptyText }) => {
  const { t } = useTranslation();

  return (
    <View className="mb-10">
      {title && (
        <Text className="text-lead font-[sans-700] text-neutral-950 dark:text-neutral-50 mb-4">
          {title}
        </Text>
      )}
      {rows.length === 0 ? (
        emptyText && (
          <Text className="text-subHeader font-[sans-400] text-neutral-600 dark:text-neutral-300 mt-2">
            {emptyText}
          </Text>
        )
      ) : (
        <>
          <View className="flex-row border-y-[1px] border-neutral-950 dark:border-neutral-50">
            <View style={{ width: '40%' }}>
              <TableCell
                text={t('admin:table_columns:helpdesk_issues:title')}
                textClassNames="font-[sans-600]"
              />
            </View>
            <View style={{ width: '40%' }}>
              <TableCell
                text={t('admin:table_columns:helpdesk_issues:link')}
                textClassNames="font-[sans-600]"
              />
            </View>
            <View style={{ width: '20%' }}>
              <TableCell
                text={t('admin:table_columns:common:status')}
                textClassNames="font-[sans-600]"
              />
            </View>
          </View>
          <ScrollView style={{ maxHeight: 320 }}>
            {rows.map((issue, index) => (
              <View
                key={index}
                className="flex-row border-b-[1px] border-neutral-950 dark:border-neutral-50"
              >
                <View style={{ width: '40%' }}>
                  <TableCell text={issue.name} />
                </View>
                <View style={{ width: '40%' }}>
                  <TableCell text={issue.linkTranslation} textClassNames={'w-full'} />
                </View>
                <View style={{ width: '20%' }}>
                  <TableCell>
                    <View className="flex-row items-center">
                      <View
                        className={cln(
                          'rounded-full w-2 h-2 mr-2',
                          issue.status === HelpdeskIssueStatus.published
                            ? 'bg-success-600 dark:bg-success-500'
                            : issue.status === HelpdeskIssueStatus.draft
                              ? 'bg-neutral-300 dark:bg-neutral-800'
                              : 'bg-danger-500',
                        )}
                      />
                      <Text
                        className={cln(
                          'text-tableRow font-[sans-400]',
                          issue.status === HelpdeskIssueStatus.draft
                            ? 'text-neutral-700 dark:text-neutral-400'
                            : 'text-neutral-950 dark:text-neutral-50',
                        )}
                      >
                        {t(`admin:search:${issue.status}`)}
                      </Text>
                    </View>
                  </TableCell>
                </View>
              </View>
            ))}
          </ScrollView>
        </>
      )}
    </View>
  );
};

export default HelpdeskIssueSimpleTable;
